import {
  FAVORITED_SCRIPT,
  FAVORITE_SCRIPT,
  FAVORITED_SCRIPT_API_ERROR,
  FAVORITED_SCRIPT_RESET_ERROR,
} from "./actionTypes";

const initialState = {
  favorites:[],
  errorFavoriteScript: false,
  status: {
    scriptId: null,
    error: false,
    loading: false,
    success: false
  },
};

const FavoriteScripts = (state = initialState, action) => {
  switch (action.type) {
      case FAVORITE_SCRIPT:
        state = {
          ...state,
          status: {
              scriptId: action?.payload?.scriptId,
              error: false,
              loading: true,
              success: false,
            },
        };
        break;
    case FAVORITED_SCRIPT:
      state = {
        ...state,
        errorFavoriteScript: false,
        favorites: action?.payload?.favoriteScript,
        status: {
            scriptId: action?.payload?.scriptId,
            error: false,
            loading: false,
            success: true,
          },
      };
      break;
    case FAVORITED_SCRIPT_API_ERROR:
      state = {
        ...state,
        errorFavoriteScript: action.payload,
      };
      break;
    case FAVORITED_SCRIPT_RESET_ERROR:
      state = {
        ...state,
        errorFavoriteScript: false,
      };
          break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default FavoriteScripts;
